import styles from "./CustomColumnMenu.module.css";

import * as React from 'react';
import { GridColumnMenuItemGroup, GridColumnMenuItem, GridColumnMenuItemContent } from '@progress/kendo-react-grid';
import { Popup } from '@progress/kendo-react-popup';

export const CustomColumnMenu = props => {
  const [menuColumns, setMenuColumns] = React.useState(props.columns);
  const [columnsExpanded, setColumnsExpanded] = React.useState(false);
  const [filterExpanded, setFilterExpanded] = React.useState(false);
  
  const onToggleColumn = id => {
    const newColumns = menuColumns.map((column, idx) => {
      return idx === id ? {
        ...column,
        show: !column.show
      } : column;
    });
    setMenuColumns(newColumns);
  };

  const onReset = event => {
    if(event) event.preventDefault();

    props.onColumnsReset();
    if (props.onCloseMenu) {
      props.onCloseMenu();
    }
  };
  const onSubmit = event => {
    if (event) {
      event.preventDefault();
    }
    props.onColumnsSubmit(menuColumns);
    if (props.onCloseMenu) {
      props.onCloseMenu();
    }
    const value = !columnsExpanded;
    setColumnsExpanded(value);
    setPopupShow(false);
  };
  const onMenuItemClick = () => {
    const value = !columnsExpanded;
    setColumnsExpanded(value);
    setPopupShow(value);
    setFilterExpanded(value ? false : filterExpanded);
  };
  
  const selectNone = event => {
    if (event) {
        event.preventDefault();
    }

    const newColumns = props.columns.map(col => {
        return {
          ...col,
          show: false
        };
      });
      setMenuColumns(newColumns);
  };

  const selectAll = event => {
    if (event) {
        event.preventDefault();
    }

    const newColumns = props.columns.map(col => {
        return {
          ...col,
          show: true
        };
      });
      setMenuColumns(newColumns);
  };

  const anchor = React.useRef(null)
  const [popupShow, setPopupShow] = React.useState(false);

  const oneVisibleColumn = menuColumns.filter(c => c.show).length === 1;
  return <div ref={anchor} >
        <GridColumnMenuItemGroup>
          <GridColumnMenuItem title={'Filter Columns'} iconClass={'k-i-columns'} onClick={onMenuItemClick} />
          <Popup margin={{ vertical: 5}} 
                anchor={anchor.current} 
                anchorAlign={{
                        vertical: 'bottom',
                        horizontal: 'right'
                        }} 
                popupAlign={{
                        vertical: 'top',
                        horizontal: 'right'
                        }} 

                popupClass={styles['popup-content']}
                show={popupShow}
          >
            <GridColumnMenuItemContent show={columnsExpanded}>
                  <div className={`k-column-list-wrapper`}>
                    <div style={{display: 'grid'}}>
                      <div style={{margin: '0 auto'}}>
                        <button className={styles.button} onClick={selectAll} >Select all</button>
                        <button className={styles.button} onClick={selectNone} >None</button>
                      </div>
                    </div>
                    <form onSubmit={onSubmit} onReset={onReset}>
                        <div className={'k-column-list'}>
                            {menuColumns.map((column, idx) => <div key={idx} className={'k-column-list-item'}>
                                <span >
                                <label htmlFor={`column-visiblity-show-${idx}`} className="k-checkbox-label" 
                                        style={{
                                            userSelect: 'none'
                                        }}
                                    >
                                    <input id={`column-visiblity-show-${idx}`} 
                                        className="k-checkbox k-checkbox-md k-rounded-md" 
                                        type="checkbox" readOnly={true} 
                                        disabled={column.show && oneVisibleColumn} 
                                        checked={column.show} 
                                        onClick={() => {
                                            onToggleColumn(idx);
                                        }} 
                                    />
                                        {column.title}
                                    </label>
                                </span>
                            </div>)}
                        </div>
                        <div style={{display: 'grid'}}>
                          <div style={{margin: '0 auto'}}>
                            <button type={'reset'} className={styles.button}>Reset</button>
                            <button className={styles.button}>Update</button>
                          </div>
                        </div>
                    </form>
                </div>
            </GridColumnMenuItemContent>
          </Popup>
        </GridColumnMenuItemGroup>
      </div>;
};